export enum BusinessEntityType {
  Provider,
  Client,
  Manufacturer,
  Consignee,
  Brand,
  InternalCompany,
}
